const ConfirmationReducer = (state = {
    userConfirmed: false,
    vehicleOptionList:[],
    leftTitle: {
        title: 'Title',
        subTitle: 'this is data',
        icon: 'place icon here'
    },
    estimate: 578

}, action) => {
    switch (action.type) {
        case ('UNCONFIRMED_MATCH'):
            console.log('unconfirmed');
            return {
                ...state
            }
        case ('CREATE_VEHICLES_CONFIRMATION_LIST'):
            return {
                ...state,
                vehicleOptionList: action.payload
            }
        case ('SET_QUOTE_ESTIMATE'):
            return{
                ...state,
                estimate: action.payload
            }
        default:
            return {
                ...state
            }
    }
};

export default ConfirmationReducer;


// WEBPACK FOOTER //
// ./src/Confirm/reducer.js